import { type NotificationPolicy } from './types';

export const NotificationPolicyObject = {
  /**
   * Creates a new NotificationPolicy object.
   * @param {Partial<NotificationPolicy>} notificationPolicy - The data for initializing the policy.
   * @returns {NotificationPolicy} The initialized policy object.
   */
  create(notificationPolicy: Partial<NotificationPolicy> = {}) {
    return {
      contactPointId: notificationPolicy?.dsContactPointId ?? null,
      dataSubscriptionId: notificationPolicy?.dsId ?? null,
    };
  },
};
